export default __webpack_public_path__ + "static/media/confirmationThumbsUp.290ca836.svg";